import React from 'react';
import { Col, Row } from 'antd';
import cx from 'classnames';

import { PasswordValidationRules } from 'utils/authUtils';
import { isMatchRegExp } from 'utils/validationUtils';

import style from './PasswordValidationRuleBox.module.less';

interface Props {
  password: string;
}

export default function PasswordValidationRuleBox(props: Props) {
  const { password } = props;
  return (
    <div className={style.validationRule}>
      <Row gutter={20}>
        <Col
          span={12}
          className={cx('validation-rule', {
            success: isMatchRegExp(
              PasswordValidationRules.LowercaseCharacter,
              password,
            ),
          })}
        >
          <span className="circle" /> One lowercase letter (e.g. abc)
        </Col>
        <Col
          span={12}
          className={cx('validation-rule', {
            success: isMatchRegExp(
              PasswordValidationRules.SpecialCharacter,
              password,
            ),
          })}
        >
          <span className="circle" /> One special character (e.g. !@#)
        </Col>
        <Col
          span={12}
          className={cx('validation-rule', {
            success: isMatchRegExp(
              PasswordValidationRules.UppercaseCharacter,
              password,
            ),
          })}
        >
          <span className="circle" /> One uppercase letter (e.g. ABC)
        </Col>
        <Col
          span={12}
          className={cx('validation-rule', {
            success: isMatchRegExp(
              PasswordValidationRules.MinimumCharacters,
              password,
            ),
          })}
        >
          <span className="circle" /> 8 characters minimum
        </Col>
        <Col
          span={12}
          className={cx('validation-rule', {
            success: isMatchRegExp(PasswordValidationRules.OneNumber, password),
          })}
        >
          <span className="circle" /> One number (e.g. 123)
        </Col>
        <Col
          span={12}
          className={cx('validation-rule', {
            success: isMatchRegExp(
              PasswordValidationRules.MaximumCharacters,
              password,
            ),
          })}
        >
          <span className="circle" /> 50 characters maximum
        </Col>
      </Row>
    </div>
  );
}
